import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import fetch from 'isomorphic-unfetch';
import config from '../config';

function requestEndpoint(env, type, dualBrand) {
  var isBosun = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var ENDPOINTS = isBosun ? config.BOSUN_ENDPOINTS : config.ENDPOINTS;
  return "".concat(ENDPOINTS[env]).concat(config.ASSETS[type]).concat(dualBrand ? '?dualBrand=true' : '');
}

function logError(msg, path) {
  var errorLog = {
    type: 'haas-error',
    msg: msg,
    path: path
  };
  console.error(JSON.stringify(errorLog));
}

function shouldInvalidateCache(variant) {
  var difference = Math.abs(Date.now() - variant.lastUpdated);
  var minutes = Math.floor(difference / 1000 / 60);
  return minutes >= config.CACHE_EXPIRY;
}

export default function headerMiddleware(environment) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  /* Default requests to Akamai (www.argos.co.uk) unless specifically provided */
  var env = environment || 'production';
  /* Default to the full header */

  var variant = config.VARIANTS.default;
  /* Ensures the internal node cache is populated on first request */

  var firstRequest = true;
  /* Flag to invalidate the internal cache and re-populate the header data */

  var cacheIsExpired = false;
  /* Switch to serving the mini header if told so in the middleware options object */

  if (options.miniHeader) {
    variant = config.VARIANTS.mini;
  }

  var endpoint = requestEndpoint(env, variant, options.dualBrand, options.isBosun);
  /* HAAS environment & file path where the server side fetch is made */

  /* Request headers */

  var headers = _objectSpread({}, config.REQUEST_HEADERS);
  /* Ensure the user agent is provided */


  if (options.userAgent) {
    headers['User-Agent'] = options.userAgent;
  } else {
    logError("".concat(config.ERR_MISSING_USER_AGENT, " ").concat(endpoint));
  }

  return function (req, res, next) {
    var cacheKey = "".concat(variant).concat(options.dualBrand ? '-dualBrand' : '');
    /* Determine if first or subsequent request for the particular header variant being asked for */

    if (global.argosHeaderService && global.argosHeaderService[cacheKey]) {
      firstRequest = false;
    }
    /* Check on every request if the cached response is within the 30 minute TTL */


    if (!firstRequest) {
      cacheIsExpired = shouldInvalidateCache(global.argosHeaderService[cacheKey]);
    }

    if (firstRequest || cacheIsExpired) {
      fetch(endpoint, {
        headers: headers
      }).then(function (result) {
        return result.json();
      }).then(function (json) {
        global.argosHeaderService = _objectSpread(_objectSpread({}, global.argosHeaderService), {}, _defineProperty({}, cacheKey, _objectSpread(_objectSpread({}, json), {}, {
          lastUpdated: Date.now()
        })));

        if (firstRequest) {
          req.argosHeaderService = global.argosHeaderService[cacheKey];
          next();
        }
      }).catch(function () {
        logError("".concat(config.ERR_SCRIPT_LOAD_FAIL, " ").concat(endpoint), req.path);

        if (firstRequest) {
          next();
        }
      });
    }

    req.argosHeaderService = global.argosHeaderService && global.argosHeaderService[cacheKey];
    if (!firstRequest) next();
  };
}